/*eslint-disable*/
import {mapState} from 'vuex';

export default {
    computed: mapState({
        user: state => state.auth.user
    }),
    methods: {
        endGame() {
            if (!this.$offline && this.user && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                this.sendStat();
            }
        }
    },
    beforeDestroy() {
        if (this.parameters && !this.parameters.infinityAmountOfExamples) {
            this.endGame();
        }
    }
}
